<template>
  <div class="modal fade show pos-invoice-modal" aria-labelledby="posInvoiceTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-dialog-centered pos-invoice-dialog">
      <div class="modal-content">
        <div class="d-flex justify-content-between align-items-center px-3 py-2 modal-head">
          <h4 class="mb-0">Create Invoice — {{ tableName }}</h4>
          <button
              @click="onClickClose"
              type="button"
              class="btn-close"
              aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <Loader v-if="loading"/>
          <div v-if="!loading && parentGroup.length" class="pos-invoice-wrap">
            <PosBilling
                :parentGroup="parentGroup"
                :companyId="companyId"
                :locations="locations"
                :productId="productId"
                v-model:locationId="locationId"
                @resetIds="onClickClose"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';
import PosBilling from '@/components/molecule/company/pos-invoice/PosBilling.vue';
import Loader from '@/components/atom/LoaderComponent';
import handleInventory from '@/services/modules/inventory';
import handleBusinessesLocations from '@/services/modules/businessesLocations';

defineProps({
  tableName: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['close']);

const route = useRoute();
const {fetchGroupParent} = handleInventory();
const {fetchBusinessLocationsList} = handleBusinessesLocations();

const companyId = route.params.companyId;
const companyQuery = `?company_id=${companyId}`;

const loading = ref(true);
const parentGroup = ref([]);
const locations = ref([]);
const locationId = ref(null);
const productId = ref(null);

onMounted(async () => {
  loading.value = true;
  await getProductHeadGroup();
  await getLocations();
  loading.value = false;
});

const getProductHeadGroup = async () => {
  const query = `${companyQuery}&product_type=finished_goods,services`;
  const res = await fetchGroupParent(query);
  if (!res.data || !res.data.length) {
    return;
  }
  parentGroup.value = res.data;
};

const getLocations = async () => {
  const locationQuery = `${companyQuery}&location_type=fg_warehouse`;
  const res = await fetchBusinessLocationsList(locationQuery);
  if (!res.status) {
    return;
  }
  locations.value = res.data;
  locationId.value = locations.value[0].id;
};

const onClickClose = () => {
  emit('close');
};
</script>

<style scoped>
.pos-invoice-dialog {
  max-width: 1320px;
  width: 95%;
  margin: 1rem auto;
  height: calc(100vh - 2rem);
}

.pos-invoice-modal .modal-content {
  height: 100%;
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-head {
  background: #DBE7F2;
  border-bottom: 1px solid #b9cee0;
  flex: 0 0 auto;
}

.modal-body {
  padding: 8px 12px;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.pos-invoice-wrap {
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.pos-invoice-wrap :deep(.row) {
  margin-left: 0;
  margin-right: 0;
}

.pos-invoice-wrap :deep(.content-border) {
  flex: 1 1 auto;
  min-height: 0;
}

.pos-invoice-wrap :deep(.content-height) {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.pos-invoice-wrap :deep(.product-list) {
  height: 100%;
}

.pos-invoice-wrap :deep(.content-border > [class*="col-"]) {
  height: 100%;
}

.pos-invoice-wrap :deep(.pos-right) {
  flex: 1;
  min-height: 0;
  height: auto;
}

.pos-invoice-wrap :deep(.pay-now-btn) {
  flex: 0 0 auto;
}
</style>
